<section class="flex flex-col gap-4 px-4 py-6 md:px-12">
  <h2 class="text-primary-900">{{ "calculator.prestation" | transloco }}</h2>
  @if (this.tripService.hasAnyPrestations()) {
    <div class="flex flex-col gap-6">
      <app-transport-section />
      <div class="flex flex-col gap-6 md:flex-row">
        <div class="flex-1">
          <app-activity-section />
        </div>
        <div class="flex-1">
          <app-accommodation-section />
        </div>
      </div>
    </div>
  } @else {
    <app-prestation-empty-state
      [title]="'prestations.emptyStateTitle' | transloco"
      [text]="'prestations.emptyStateText' | transloco"
      [buttonLabel]="'prestations.addPrestation' | transloco"
      [action]="openPrestationModal"
    />
  }
</section>
<app-prestation-modal />
